module.exports = __webpack_public_path__ + "media/10.978da3dc.mp3";